export default __webpack_public_path__ + "static/marbel-markdown-901bc3a119c42e69db69e1fd799a0584.jpg";